import { AvailabilityTimeRange } from "./availabilityTimeRange";

export class AvailabilityTemplateDay {
    public isAvailable: boolean = false;
    public weekNumber: number = 0;
    public dayOfWeek: number = 0;
    public availabilityTimeRange: AvailabilityTimeRange[] = [];
}